// Mock data for Leonard RR Cox portfolio

export const siteInfo = {
  name: "Leonard RR Cox",
  shortName: "LRRC",
  tagline: "Professional Composer and Audio Specialist",
  description:
    "Discover professional music and multimedia services for film, video games, and more. Elevate your project with expert audio production.",
  email: "leonardrrcox@gmail.com",
  location: "Based in New York \u2014 Worldwide",
  spotifyUrl: "https://open.spotify.com/artist/1psXifSjsaeDHKhiiDpgcP",
  youtubeUrl: "https://www.youtube.com/channel/UCGm6grFZckmWW_JfyWdiKvA",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Music", path: "/music" },
  { label: "Work", path: "/work" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const heroImage =
  "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/514c90d7-6600-4661-b9b2-86b965b0ca16/Cox-Leonard.jpeg";

export const aboutImages = {
  studio:
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/def2bb45-c55f-434e-8fca-70f529687f98/IMG_3656+%281%29.jpg",
  keyboard:
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/93e00029-f7ab-4066-ab25-047006e8e996/IMG-3517.jpg",
};

export const aboutBio = [
  "Leonard R.R. Cox was born in 2001 in Spokane Washington. From a young age, he displayed a keen interest in the creation of music, which was nurtured by his supportive family and educators. He attended Joel E Ferris High School, where he excelled academically and participated in various extracurricular activities that shaped his early ambitions.",
  "Cox pursued higher education at University of the Pacific\u2019s Conservatory of Music, majoring in Music Composition with a primary in Percussion. His undergraduate years were marked by significant achievements, including four full ensemble premiers of his percussion, orchestra, and wind band pieces.",
  "Leonard R.R. Cox's professional career began at Continuum XR, where he became their first In-house Audio Specialist. Over the years, Cox has held various prestigious musical positions in the credits of truly wonderful and talented projects and people, including Skylar Gisonda in Memento Mori, Spencer Cook with Monkey See Monkey Doo, Ben Olding with Clique games and Dragon Fist VR and loads more, each contributing to his reputation as a leading expert as a Musical Composer.",
  "Outside of his professional endeavors, Leonard R.R. Cox is known for his passion in his hobbies. He is actively creating outside of music as well, starting multiple companies like Cox Games, FMK, and Pickleball Impact Tape. This demonstrates his dedication to the word \u201Ccreation\u201D as he will keep producing high quality products everywhere he goes.",
  "Through his career, Leonard R.R. Cox has exemplified excellence, innovation, and integrity, making him a respected and admired young figure in the Music Composition community.",
];

export const aboutSummary =
  "Leonard R. R. Cox is a composer and sound designer specializing in cinematic music for video games and Film. His work has contributed to multiple Top 10 titles on the Meta Store, blending film scoring techniques with adaptive game audio systems. With a background in film composition and interactive design, Leonard focuses on creating emotionally resonant, gameplay-responsive scores.";

export const musicReel = {
  title: "Music Reel",
  subtitle:
    "Selected work from Top 10 Meta Store VR titles and cinematic game projects.",
  youtubeId: "lAIlcunG2Mk",
};

// Categories: "film" | "games" | "singles"
export const albums = [
  { id: "1vZcCwZK9u6mgDJX97YwN8", title: "Trust Me, I'm a Barber", subtitle: "Original Soundtrack · Leonard RR Cox & Evan Cox", type: "Album", year: "2026", category: "games", cover: "/images/barber.jpg" },
  { id: "35sv6h4QXM5p2RpUFPF6zu", title: "UG Vol. 2", subtitle: "Original Soundtrack", type: "Album", year: "2026", category: "games", cover: "/images/ug-vol2.jpg" },
  {
    id: "4nC5euuZgKwjV2IxBQxv4i",
    title: "Red Ruby",
    subtitle: "Original Motion Picture Soundtrack",
    type: "EP",
    year: "2026",
    tracks: 4,
    category: "film",
    cover: "https://i.scdn.co/image/ab67616d0000b27306c308a7f44b50be6d88ca17",
  },
  {
    id: "531ZvcL43oE34NA38tRFFp",
    title: "Momento Mori",
    subtitle: "Original Motion Picture Soundtrack",
    type: "Album",
    year: "2026",
    tracks: 9,
    category: "film",
    cover: "https://i.scdn.co/image/ab67616d0000b27300365c839db1afecfe35ecd5",
  },
  {
    id: "0Qv6IrZo0bPYVpKEwRHAYC",
    title: "McGeorge School of Law Documentary",
    subtitle: "Original Motion Picture Soundtrack",
    type: "EP",
    year: "2026",
    tracks: 5,
    category: "film",
    cover: "https://i.scdn.co/image/ab67616d00001e029b0160d100351fa0193bc2d2",
  },
  {
    id: "7kQpba32afnvxKooWB2pry",
    title: "Impulso",
    subtitle: "Original Motion Picture Soundtrack",
    type: "EP",
    year: "2026",
    tracks: 5,
    category: "film",
    cover: "https://i.scdn.co/image/ab67616d00001e02c460ebc54a961dc0ad2c2970",
  },
  {
    id: "3BBEPXsQD11vQHiYKLAUh5",
    title: "Cactus Jam",
    subtitle: "Original Soundtrack",
    type: "Single",
    year: "2026",
    tracks: 2,
    category: "games",
    cover: "https://i.scdn.co/image/ab67616d00001e020bbb3d67df3dadbc6574c079",
  },
  {
    id: "4Yv1QhA6THxxn1UF2ntBFR",
    title: "UG",
    subtitle: "Original Soundtrack",
    type: "Album",
    year: "2026",
    tracks: 10,
    category: "games",
    cover: "https://i.scdn.co/image/ab67616d00001e0250c13a3ef05922ec4c81f653",
  },
  {
    id: "2scTstOBAM26SN4Pb2JyCi",
    title: "Monkey Doo",
    subtitle: "Original Game Soundtrack",
    type: "Album",
    year: "2024",
    tracks: 9,
    category: "games",
    cover: "https://i.scdn.co/image/ab67616d00001e028a46d73f134102c62322e7e9",
  },
  {
    id: "6VoYrsNsUo3fiP5z5nX68g",
    title: "Dramatic Scores & Songs",
    subtitle: "LRRC Originals",
    type: "Album",
    year: "2023",
    tracks: 19,
    category: "games",
    cover: "https://i.scdn.co/image/ab67616d00001e020b9c7ddc8af54f106b946cd6",
  },
  {
    id: "0ZdxDgjlWKWKLcNY8OQ3NB",
    title: "Diner",
    subtitle: "Single",
    type: "Single",
    year: "2025",
    tracks: 1,
    category: "singles",
    cover: "https://i.scdn.co/image/ab67616d00001e0272524850b640ffbb48c2c6a0",
  },
  {
    id: "20h1NCfZAuydFZSuDwXMpJ",
    title: "The Finale",
    subtitle: "Single",
    type: "Single",
    year: "2023",
    tracks: 1,
    category: "singles",
    cover: "https://i.scdn.co/image/ab67616d00001e02f133e24fb68ea8479aca4260",
  },
  {
    id: "4e9FBCYALoVZ8XjxYiR67U",
    title: "Angel Earth Edition",
    subtitle: "AEE \u00b7 Roaming + First Flight",
    type: "VR Score",
    year: "2023",
    tracks: 2,
    category: "games",
    cover:
      "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/2b1f05ab-7f72-4504-8605-7a2adaff0535/IMG_8A1667B1332D-1.jpeg",
    spotifyType: "track",
  },
];

// Helper to fetch a Spotify embed URL (supports album, track, playlist)
export const spotifyEmbed = (id, type = "album") => `https://open.spotify.com/embed/${type}/${id}?utm_source=generator`;
export const spotifyAlbumEmbed = (id) => spotifyEmbed(id, "album");
export const spotifyAlbumLink = (id) => `https://open.spotify.com/album/${id}`;
export const spotifyTrackLink = (id) => `https://open.spotify.com/track/${id}`;
export const spotifyOpenLink = (id, type = "album") => `https://open.spotify.com/${type}/${id}`;

// Featured game projects with their own posters AND linked Spotify content
export const gameProjects = [
  {
    title: "UG",
    subtitle: "Original Soundtrack",
    label: "Meta Number 1",
    id: "4Yv1QhA6THxxn1UF2ntBFR",
    spotifyType: "album",
    cover: "https://i.scdn.co/image/ab67616d00001e0250c13a3ef05922ec4c81f653",
    poster:
      "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/679974ac-b117-47aa-ad03-2acf8f093cc1/ORIGIONAL+SOUNDTRACK.JPEG",
    tracks: 10,
    year: "2026",
    youtubeId: "",
  },
  {
    title: "Dragon Fist VR",
    subtitle: "Music & Ambience",
    label: "Meta Top 5",
    // No standalone album yet; links to compilation that contains its cues
    id: "6VoYrsNsUo3fiP5z5nX68g",
    spotifyType: "album",
    cover: "https://i.scdn.co/image/ab67616d00001e020b9c7ddc8af54f106b946cd6",
    poster:
      "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/7ae83168-0398-472e-851b-de8ea2f9fe10/df+library+capsule+4.6.22.JPEG",
    tracks: null,
    year: "2023",
    youtubeId: "lAIlcunG2Mk",
  },
  {
    title: "Monkey Doo",
    subtitle: "Original Game Soundtrack",
    label: "Meta Top 5",
    id: "2scTstOBAM26SN4Pb2JyCi",
    spotifyType: "album",
    cover: "https://i.scdn.co/image/ab67616d00001e028a46d73f134102c62322e7e9",
    poster:
      "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/65e674a9-7cbd-49a7-9c6d-256be5159c90/IMG_9885.jpg",
    tracks: 9,
    year: "2024",
    youtubeId: "",
  },
  {
    title: "Cactus Jam",
    subtitle: "Original Soundtrack",
    label: "VR",
    id: "3BBEPXsQD11vQHiYKLAUh5",
    spotifyType: "album",
    cover: "https://i.scdn.co/image/ab67616d00001e020bbb3d67df3dadbc6574c079",
    poster:
      "https://i.scdn.co/image/ab67616d0000b2730bbb3d67df3dadbc6574c079",
    tracks: 2,
    year: "2026",
    youtubeId: "",
  },
  {
    title: "Angel Earth Edition",
    subtitle: "AEE \u00b7 Roaming + First Flight",
    label: "VR",
    // Plays AEE Roaming track. Album: Dramatic Scores & Songs
    id: "4e9FBCYALoVZ8XjxYiR67U",
    spotifyType: "track",
    cover: "https://i.scdn.co/image/ab67616d00001e020b9c7ddc8af54f106b946cd6",
    poster:
      "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/2b1f05ab-7f72-4504-8605-7a2adaff0535/IMG_8A1667B1332D-1.jpeg",
    tracks: 2,
    year: "2023",
    youtubeId: "",
    extraTracks: [
      { title: "AEE Roaming", id: "4e9FBCYALoVZ8XjxYiR67U" },
      { title: "AEE First Flight", id: "5ks5GgKPbeSykbSrQS4TWq" },
    ],
  },
];

export const gameCredits = {
  title: "Cinematic Composer for Video Games & VR",
  subtitle: "Meta Top 5 VR Games",
  projects: [
    {
      title: "Dragon Fist VR",
      label: "Meta Top 5",
      image:
        "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/7ae83168-0398-472e-851b-de8ea2f9fe10/df+library+capsule+4.6.22.JPEG",
      youtubeId: "lAIlcunG2Mk",
    },
    {
      title: "Monkey Doo",
      label: "Meta Top 5",
      image:
        "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/65e674a9-7cbd-49a7-9c6d-256be5159c90/IMG_9885.jpg",
      youtubeId: "",
    },
    {
      title: "UG VR",
      label: "Meta Number 1",
      image:
        "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/679974ac-b117-47aa-ad03-2acf8f093cc1/ORIGIONAL+SOUNDTRACK.JPEG",
      youtubeId: "",
    },
  ],
  gallery: [
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/98cf97ca-ca6c-41e3-9ec3-e6ae213cbf5c/ORIGIONAL+SOUNDTRACK.JPEG?format=500w",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/a56f88f5-84bb-4c0f-a5c5-66c2f2441dc4/df+library+capsule+4.6.22.JPEG?format=500w",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/9fef4cac-683c-4c1e-bbe3-231738a7ba52/IMG_9885.jpg?format=500w",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/2b1f05ab-7f72-4504-8605-7a2adaff0535/IMG_8A1667B1332D-1.jpeg?format=500w",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/1652837863547-IU6JMTQ7G1R8ORFURB8R/Render_4.JPG?format=500w",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/e6a90a32-bac5-4c46-affa-b2719a094be4/89224FAB-3F49-472C-B058-EB559548CFCC.PNG?format=750w",
  ],
};

export const filmCredits = {
  title: "Documentary | Feature Film | Short Film",
  posters: [
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/f3a2fcdc-7df2-4f3f-8e12-08b8699edee1/McGeroege+photyo.png",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/b06c6f3d-7736-4a96-871d-d8e4d09fa7f1/ewtghswrth.png",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/024ada00-0d34-48a8-8d2d-223b80e31224/samantha+and+fishersmans+dream.png",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/66c3972f-0bbc-4676-8a9a-f19de99bcbea/IMPULSO_FINAL_POSTER-01.png",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/aad82d0d-545f-4410-999a-8ec94dda4023/these+are+for+you.png",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/d5e00852-144c-4a0d-a54b-3f9e99504493/7.JPEG",
    "https://images.squarespace-cdn.com/content/v1/6281713138beb96cc5047986/5c7fdda2-0c56-482c-89f7-d2eda9113fbc/sith+empire.png",
  ],
  videos: [
    { title: "Addicted to Phones", youtubeId: "QQZ431VJnLI" },
    { title: "Rescore of Trese", youtubeId: "qDjbwHkBpv8" },
    { title: "Momento Mori (Sneak Peek)", youtubeId: "HHdzqHpDCEQ" },
    { title: "Impulso (Original Soundtrack)", youtubeId: "TaVq1_7WKHg" },
    { title: "#MyStargirlScore", youtubeId: "hiNutxRJ_jo" },
    { title: "Ocean CueTube Rescore", youtubeId: "LwnVk75Z0L0" },
  ],
};
